import React from 'react';
import Profile from '../components/auth/Profile';

export default function ProfilePage() {
  return <Profile />;
}
